export const getGroupWeight = (totalWeight, totalQuantity, quantity) => {
  return parseFloat(((totalWeight / totalQuantity) * quantity).toFixed(2));
};
